import axios from 'axios'
import Vue from 'vue'
import Console from '../helpers/Console'

// let isTokenRefreshing = false

let client = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 150000,
  headers: {
    'Accept': 'application/json'
  }
})

client.interceptors.request.use((config) => {
  let accessToken = sessionStorage.getItem('access_token')
  
  if (accessToken) {
    config.headers['Authorization'] = 'Bearer ' + accessToken
  }
  
  return config
})

client.interceptors.response.use((response) => {
  
  Console.log(response)
  
  return response
}, (error) => {
  
  Console.log(error.response)
  
  if (typeof error.response !== undefined) {
    
    if (error.response.status === 404) {
      Vue.notify({
        type: 'error',
        title: 'Errore 404',
        text: 'pagina non trovata'
      })
    }
    
    if (error.response.status === 500) {
      Vue.notify({
        type: 'error',
        title: 'Errore 500',
        text: error.response.data.message
      })
    }
    
    if (error.response.status === 422) {
      Vue.notify({
        type: 'error',
        title: 'Errore 422',
        text: error.response.data.message
      })
    }
    
  } else if (typeof error.code !== 'undefined' && error.code === 'ECONNABORTED') {
    Notification.error('Connection aborted: ' + error.message)
  } else {
    Notification.error(error.message)
  }
  
  // Do something with response error
  throw error
})

export default client